document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.side-guide').forEach(function (container) {
    const openBtn = container.querySelector('[data-open-size-guide]');
    const dialog = container.querySelector('[data-size-guide-dialog]');
    const closeBtn = container.querySelector('[data-close-size-guide]');

    if (openBtn && dialog && closeBtn) {
      openBtn.addEventListener('click', () => {
        dialog.showModal();
      });

      closeBtn.addEventListener('click', () => {
        dialog.close();
      });

      // Optional: close dialog when clicking outside the content
      dialog.addEventListener('click', (e) => {
        const rect = dialog.getBoundingClientRect();
        const clickedInDialog =
          rect.top <= e.clientY &&
          e.clientY <= rect.top + rect.height &&
          rect.left <= e.clientX &&
          e.clientX <= rect.left + rect.width;
        if (!clickedInDialog) {
          dialog.close();
        }
      });
    }
  });
});
